import axiosClient from "../api/axiosClient";

type ReportResponse = {
  loan_details: any[];
  transactions: any[];
  from_date: string;
  to_date: string;
  total_loans: number;
  total_loan_amount: number;
  total_interest_amount: number;
  total_received_amount: string | number;
  total_outstanding: number;
  total_document_charges: number | string;
};

async function fetchReport(
  from_date: string,
  to_date: string,
): Promise<ReportResponse> {
  const url = `/reports?from_date=${encodeURIComponent(from_date)}&to_date=${encodeURIComponent(to_date)}`;
  const res = await axiosClient.post<ReportResponse>(url);
  return res.data;
}

export default { fetchReport };
